import React, { createContext, useContext, useEffect, useState } from 'react';

const StoreFilterContext = createContext({ store: 'todas', setStore: () => {} });

export function StoreFilterProvider({ children }) {
  const [store, setStoreState] = useState(() => localStorage.getItem('canales_store_filter') || 'todas');

  const setStore = (s) => {
    setStoreState(s);
    if (s && s !== 'todas') {
      localStorage.setItem('canales_store_filter', s);
    } else {
      localStorage.removeItem('canales_store_filter');
    }
  };

  useEffect(() => {
    // sync across tabs
    const handler = (e) => {
      if (e.key === 'canales_store_filter') {
        setStoreState(e.newValue || 'todas');
      }
    };
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, []);

  return (
    <StoreFilterContext.Provider value={{ store, setStore }}>
      {children}
    </StoreFilterContext.Provider>
  );
}

export const useStoreFilter = () => useContext(StoreFilterContext);
